export const tabletSize = '634px'
export const desktopSize = '1206px'
